import AuthService from '@/services/auth';
import UserService from '@/services/user';
import forEach from "lodash/forEach";

export default {
	namespaced: true,
	state: {
	},

	getters: {
		async getUserData({ commit, state, getters, dispatch }) {
			try {
				const response = await AuthService.getUserData();
				//window.localStorage.setItem('user_data', JSON.stringify(response.data.attributes));
				return response;
			} catch (e) {
				console.log(e);
			}
		}
	},

	actions: {
		async logIn({ commit, state, getters, dispatch }, payload) {
			const { email, password } = payload;

			const response = await AuthService.logIn(email, password);

			if (!response.data.success) {
				return response;
			} else {
				let user_attributes = response.data.attributes.user;

				let user_permissions = [];
				user_attributes.roles.filter(role => { 
				forEach(role.permissions ,permission => user_permissions.push(permission.name))
				delete role.permissions;
				delete role.pivot;
				})
			
				user_permissions = [...new Set(user_permissions)]
				delete user_attributes.permissions

				user_attributes.permissions = user_permissions
				window.localStorage.setItem('access_token', response.data.attributes.token)
				window.localStorage.setItem('user_data', JSON.stringify(user_attributes))
				window.localStorage.setItem('user_role', user_attributes.roles[0].name)
				const category = await AuthService.getCategoryId()
				window.localStorage.setItem('category', JSON.stringify(category.data[0]))
				const company = await UserService.getCompanyById(user_attributes.company_id)
				window.localStorage.setItem('company', JSON.stringify(company.data.attributes))
				const userAttachment = await AuthService.getUserData()
				window.localStorage.setItem('user_attachment', JSON.stringify(userAttachment.data.attributes.user_attachment));
				return response;
			}
		},
		async logInCustomer({ commit, state, getters, dispatch }, payload) {
			const { email, password } = payload;

			const response = await AuthService.logInCustomer(email, password);

			if (!response.data.success) {
				return response;
			} else {
				let user_attributes = response.data.attributes.user;

				let user_permissions = [];
				user_attributes.roles.filter(role => { 
				forEach(role.permissions ,permission => user_permissions.push(permission.name))
				delete role.permissions;
				delete role.pivot;
				})
			
				user_permissions = [...new Set(user_permissions)];
				delete user_attributes.permissions;

				user_attributes.permissions = user_permissions;
				return response;
			}
		},
		async logOut({ commit, state, getters, dispatch }) {
			await AuthService.logOut();
		}
	},

	mutations: {
		SET_VALUE_FROM_API(state, payload) {
			state.valueFromApi = payload;
		}
	}
};
